<template>
<div class="chapter">
<div class="inner_page">
<h1 class="section"><strong class="bold">FEROCITY</strong></h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ferocity_00001.vue?ca0b27aa